var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupAirplaneModeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#GroupAirplaneModeActive_svg__clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 17.5V16l-5.474-3.75V8.125C7.526 7.503 7.068 7 6.5 7c-.568 0-1.026.503-1.026 1.125v4.125L0 16v1.5l5.474-1.875v4.125l-1.369 1.125V22l2.395-.75 2.395.75v-1.125L7.526 19.75v-4.125L13 17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 13.2v-1.6l-6.316-4V3.2c0-.664-.529-1.2-1.184-1.2a1.19 1.19 0 00-1.184 1.2v4.4L9 11.6v1.6l6.316-2v4.4l-1.58 1.2V18l2.764-.8 2.763.8v-1.2l-1.579-1.2v-4.4l6.316 2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "GroupAirplaneModeActive_svg__clip0_1_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgGroupAirplaneModeActive;